import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'Yazaki',
  logo: { name: 'Yazaki', src: '/logo/yazakicard.png' },
  portrait: { src: '/photo/portrait-tekin-gulsen.png', alt: 'Tekin Gülşen' },
  quote: [
    'Digitopia’s Digital Maturity Index gave us the clarity about the positive progress we '
    + 'have made recently in creating business value with digitalization. We also had a '
    + 'chance to benchmark ourselves with the industry peers. Digitopia’s insightful '
    + 'recommendations helped us fine tune and confirm our strategy. This partnership has '
    + 'been a key milestone in our journey to innovation and digitalization.',
  ],
  attribution: 'Tekin Gülşen, VP of IT Y-EMEA and Global Applications',
  story: 'yazaki',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 0
